<div class="hub-page">
  <div class="hub">
    <!-- Cabecera -->
    <header class="hub-head">
      <h2>Enviar remesa</h2>
      <p>Cotiza y envía en un solo paso</p>
      <p>Horario de envíos: Todos los días · 04:00–23:00</p>
    </header>

    <!-- ═══════════ Paso 2 · Beneficiario ═══════════
         La libreta se resuelve por PAÍS DESTINO, no por origen. -->
    <div class="step2" *ngIf="paso === 'beneficiario'">
      <!-- Resumen de lo cotizado, siempre a la vista -->
      <div class="quote-strip">
        <button type="button" class="back" (click)="volverACotizacion()">
          &lsaquo;
        </button>
        <div class="qs-txt">
          <span class="qs-l">Envías a {{ destinoMeta?.nombre }}</span>
          <span class="qs-v">
            {{ cotizacion?.monto | number: "1.0-2" }}
            {{ cotizacion?.monedaOrigen }}
            &rarr;
            <b
              >{{ cotizacion?.recibe | number: cotizacion?.decimales }}
              {{ cotizacion?.monedaDestino }}</b
            >
          </span>
        </div>
      </div>

      <div class="s2-body">
        <div class="sect-label">
          {{ aCuentaPropia ? "¿A cuál de tus cuentas?" : "¿Quién recibe?" }}
        </div>

        <div class="finder" *ngIf="beneficiarios.length">
          <input
            type="text"
            [(ngModel)]="busqueda"
            placeholder="Buscar por nombre, banco o cuenta"
          />
        </div>

        <!-- Cargando -->
        <p class="s2-msg" *ngIf="beneficiariosCargando">
          Cargando beneficiarios…
        </p>

        <!-- Error -->
        <div class="alert" *ngIf="!beneficiariosCargando && beneficiariosError">
          {{ beneficiariosError }}
        </div>

        <!-- El alta guardó pero no se pudo seguir con ese beneficiario. No es
             un error: no se perdió nada. -->
        <p
          class="hint-closed"
          *ngIf="!beneficiariosCargando && avisoBeneficiario"
        >
          {{ avisoBeneficiario }}
        </p>

        <!-- Vacío -->
        <p
          class="s2-msg"
          *ngIf="
            !beneficiariosCargando &&
            !beneficiariosError &&
            !avisoBeneficiario &&
            !beneficiarios.length
          "
        >
          {{
            aCuentaPropia
              ? "Todavía no tienes cuentas de retiro en Chile. Agrega la primera."
              : "Todavía no tienes beneficiarios para este destino. Agrega el primero."
          }}
        </p>

        <!-- Contador: si hay más de los que entran, avisamos que se desplaza -->
        <p
          class="bencount"
          *ngIf="!beneficiariosCargando && beneficiarios.length"
        >
          {{ beneficiariosFiltrados.length }}
          {{
            aCuentaPropia
              ? beneficiariosFiltrados.length === 1
                ? "cuenta"
                : "cuentas"
              : beneficiariosFiltrados.length === 1
                ? "beneficiario"
                : "beneficiarios"
          }}
          <span *ngIf="hayMasBeneficiarios">· desplaza para ver todos</span>
        </p>

        <!-- Lista: muestra 5 y scrollea dentro de su propio contenedor -->
        <div
          class="benlist"
          [class.scrollable]="hayMasBeneficiarios"
          *ngIf="!beneficiariosCargando && beneficiarios.length"
        >
          <button
            *ngFor="let b of beneficiariosFiltrados"
            type="button"
            class="ben"
            [class.on]="seleccionado?.id === b.id"
            [class.locked]="b.bloqueado"
            [disabled]="b.bloqueado"
            (click)="seleccionar(b)"
          >
            <span class="bavatar">{{ b.titulo.charAt(0) }}</span>
            <span class="btxt">
              <span class="bname">{{ b.titulo }}</span>
              <span class="bsub" *ngIf="b.subtitulo">{{ b.subtitulo }}</span>
              <span class="bbadges">
                <span class="bb" *ngFor="let t of b.badges">{{ t }}</span>
              </span>
              <span class="block" *ngIf="b.bloqueado">{{
                b.motivoBloqueo
              }}</span>
            </span>
            <span class="bchk"></span>
          </button>

          <p class="s2-msg" *ngIf="busqueda && !beneficiariosFiltrados.length">
            {{ aCuentaPropia ? "Ninguna cuenta" : "Ningún beneficiario" }}
            coincide con "{{ busqueda }}".
          </p>
        </div>

        <button
          type="button"
          class="btn ghost add"
          [disabled]="abriendoAlta"
          (click)="nuevoBeneficiario()"
        >
          <ng-container *ngIf="!abriendoAlta">{{
            aCuentaPropia ? "+ Agregar cuenta en Chile" : "+ Agregar beneficiario"
          }}</ng-container>
          <ng-container *ngIf="abriendoAlta">Abriendo…</ng-container>
        </button>

        <p class="s2-note" *ngIf="destino === 'CO'">
          Los beneficiarios de Bre-B y de transferencia bancaria son distintos:
          si cambias la forma de entrega, tienes que elegir uno del otro tipo.
        </p>
      </div>

      <div class="cta">
        <button
          type="button"
          class="btn primary"
          [disabled]="!puedeIrAResumen"
          (click)="irAResumen()"
        >
          Continuar al resumen &rarr;
        </button>
        <p class="cta-note">La tasa se vuelve a validar antes de enviar.</p>
      </div>
    </div>

    <!-- ═══════════ Paso 3 · Resumen ═══════════ -->
    <div class="step3" *ngIf="paso === 'resumen'">
      <div class="quote-strip">
        <button type="button" class="back" (click)="volverABeneficiario()">
          &lsaquo;
        </button>
        <div class="qs-txt">
          <span class="qs-l">Confirma tu envío</span>
          <span class="qs-v">Revisa antes de enviar</span>
        </div>
      </div>

      <div class="s2-body">
        <!-- La tasa cambió mientras confirmaba: NO se envió nada -->
        <div class="ratechange" *ngIf="avisoCambioTasa">
          <div class="rc-h">La tasa cambió</div>
          <p>{{ avisoCambioTasa.mensaje }}</p>
          <div class="rc-cmp">
            <span>
              Antes
              <b
                >{{
                  avisoCambioTasa.recibeAnterior | number: cotizacion?.decimales
                }}
                {{ avisoCambioTasa.cotizacion.monedaDestino }}</b
              >
            </span>
            <span>
              Ahora
              <b
                >{{
                  avisoCambioTasa.cotizacion.recibe
                    | number: cotizacion?.decimales
                }}
                {{ avisoCambioTasa.cotizacion.monedaDestino }}</b
              >
            </span>
          </div>
          <p class="rc-note">
            No se envió nada. Confirma de nuevo si estás de acuerdo.
          </p>
        </div>

        <div class="sumcard">
          <div class="sumhero">
            <div class="l">
              {{ aCuentaPropia ? "Recibes en tu cuenta" : "El beneficiario recibe" }}
            </div>
            <div class="big">
              {{ cotizacion?.recibe | number: cotizacion?.decimales }}
              {{ cotizacion?.monedaDestino }}
            </div>
          </div>
          <div class="sumrow">
            <span class="k">Destino</span>
            <span class="v"
              >{{ destinoMeta?.nombre }} · {{ cotizacion?.monedaDestino }}</span
            >
          </div>
          <div class="sumrow">
            <span class="k">{{ aCuentaPropia ? "Tu cuenta" : "Beneficiario" }}</span>
            <span class="v">{{ seleccionado?.titulo }}</span>
          </div>
          <div class="sumrow" *ngIf="seleccionado?.subtitulo">
            <span class="k">Cuenta</span>
            <span class="v">{{ seleccionado?.subtitulo }}</span>
          </div>
          <div class="sumrow">
            <span class="k">Tú envías</span>
            <span class="v">
              {{ cotizacion?.monto | number: "1.0-2" }}
              {{ cotizacion?.monedaOrigen }}
            </span>
          </div>
          <!-- La misma tasa que vio al cotizar, y la misma cuenta: no puede
               cambiar de criterio entre pantalla y pantalla. -->
          <div class="sumrow" *ngIf="tasaVisible">
            <span class="k">{{ etiquetaTasa }}</span>
            <span class="v">
              1 {{ cotizacion?.monedaOrigen }} =
              {{ tasaVisible | number: fmtTasa }}
              {{ cotizacion?.monedaDestino }}
            </span>
          </div>
          <div class="sumrow" *ngIf="hayComision && subtotal != null">
            <span class="k">Subtotal</span>
            <span class="v">
              {{ subtotal | number: cotizacion?.decimales }}
              {{ cotizacion?.monedaDestino }}
            </span>
          </div>
          <div class="sumrow">
            <span class="k">Comisión</span>
            <span
              class="v"
              *ngIf="cotizacion?.sinComision"
              style="color: #12a150"
              >Sin comisión</span
            >
            <span class="v" *ngIf="hayComision">
              − {{ cotizacion?.comision | number: fmtComision }}
              {{ cotizacion?.monedaDestino }}
            </span>
          </div>
          <div class="sumrow">
            <span class="k">Llega en</span>
            <span class="v">{{ cotizacion?.etaLabel }}</span>
          </div>
        </div>

        <!-- Posible duplicado: requiere confirmación explícita -->
        <div class="dupe" *ngIf="envioDuplicado">
          <div class="rc-h">¿Es un envío nuevo?</div>
          <p>{{ envioError?.mensaje }}</p>
          <div class="dupe-actions">
            <button
              type="button"
              class="btn ghost"
              [disabled]="navegando"
              (click)="irAlHistorial()"
            >
              Ver mi historial
            </button>
            <button
              type="button"
              class="btn primary"
              [disabled]="enviando"
              (click)="enviarIgual()"
            >
              Sí, enviar igual
            </button>
          </div>
        </div>

        <!-- Error accionable -->
        <div
          class="alert"
          *ngIf="envioError && !envioDuplicado && !envioAmbiguo"
        >
          {{ envioError.mensaje }}
          <div class="alert-op" *ngIf="envioError.contactarOperador">
            Comunícate con un operador de Aguacate para resolverlo.
          </div>
        </div>
      </div>

      <div class="cta" *ngIf="!envioDuplicado">
        <button
          type="button"
          class="btn primary"
          [disabled]="enviando"
          (click)="confirmarEnvio()"
        >
          {{
            enviando
              ? "Enviando…"
              : avisoCambioTasa
                ? "Confirmar con la nueva tasa"
                : "Enviar remesa"
          }}
        </button>
        <p class="cta-note">{{ notaTasa }}</p>
      </div>
    </div>

    <!-- ═══════════ Paso 4 · Resultado ═══════════ -->
    <div class="step4" *ngIf="paso === 'listo'">
      <!-- Éxito -->
      <div class="done" *ngIf="envioOk">
        <div class="check">
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M5 13l4 4L19 7"
              stroke="#12A150"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <h3>¡Envío en camino!</h3>
        <p class="done-amount">
          <b
            >{{ envioOk.recibe | number: cotizacion?.decimales }}
            {{ envioOk.monedaDestino }}</b
          >
          {{ aCuentaPropia ? "a tu cuenta" : "para" }} {{ seleccionado?.titulo }}
        </p>
        <p class="done-meta" *ngIf="envioOk.referencia">
          Operación <b>#{{ envioOk.referencia }}</b>
        </p>
        <p class="done-meta">
          Estado: <b>{{ envioOk.estado }}</b>
        </p>
        <p class="done-note">{{ notaResultado }}</p>

        <!-- Comprobante: copia el detalle del envío al portapapeles, listo
             para pegar en WhatsApp o donde el usuario quiera. -->
        <button
          type="button"
          class="btn ghost share"
          *ngIf="comprobante"
          [disabled]="copiando"
          (click)="copiarComprobante()"
        >
          <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <rect
              x="7"
              y="7"
              width="9.5"
              height="11"
              rx="2"
              stroke="currentColor"
              stroke-width="1.7"
            />
            <path
              d="M13 4.5H5.5a2 2 0 00-2 2V14"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
            />
          </svg>
          {{ copiando ? "Copiando…" : "Copiar comprobante" }}
        </button>
        <p class="share-msg" *ngIf="comprobanteMsg" role="status">
          {{ comprobanteMsg }}
        </p>
      </div>

      <!-- Resultado incierto: NUNCA ofrecer reintentar a ciegas -->
      <div class="done warn" *ngIf="envioAmbiguo">
        <div class="check warn">
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M12 8v5M12 16.5v.5"
              stroke="#C98A00"
              stroke-width="2.5"
              stroke-linecap="round"
            />
            <circle cx="12" cy="12" r="9" stroke="#C98A00" stroke-width="2" />
          </svg>
        </div>
        <h3>No pudimos confirmar tu envío</h3>
        <p class="done-note">{{ envioError?.mensaje }}</p>
        <button
          type="button"
          class="btn primary"
          [disabled]="navegando"
          (click)="irAlHistorial()"
        >
          Revisar mi historial
        </button>
      </div>

      <div class="done-actions">
        <button
          type="button"
          class="btn primary"
          [disabled]="navegando"
          (click)="irAlInicio()"
        >
          Ir al inicio
        </button>
        <button
          type="button"
          class="btn ghost"
          [disabled]="navegando"
          (click)="nuevoEnvio()"
        >
          Hacer otro envío
        </button>
      </div>
    </div>

    <!-- En escritorio se parte en dos columnas; en móvil y tablet es una sola. -->
    <div class="hub-grid" *ngIf="paso === 'cotizacion'">
      <!-- ═══════════ Columna: qué envías ═══════════ -->
      <section class="col col-form">
        <!-- ═══ Pagas con — cada moneda muestra su saldo ═══ -->
        <div class="sect-label">Pagas con</div>
        <div class="wallets">
          <button
            *ngFor="let o of origenes"
            type="button"
            class="wallet"
            [class.on]="origen === o"
            [class.short]="saldoNoAlcanza(o)"
            (click)="selectOrigen(o)"
          >
            <img
              class="wico"
              [src]="
                o === 'CLP'
                  ? 'assets/flags/chile.png'
                  : o === 'VES'
                    ? 'assets/flags/venezuela.png'
                    : 'assets/icons/USDT_Logo.png'
              "
              alt=""
            />
            <span class="wtxt">
              <span class="wname">{{ labelOrigen(o) }}</span>
              <span class="wbal" *ngIf="saldoDe(o) !== null">
                {{ saldoDe(o) | number: decimalesSaldo(o) }} {{ o }}
              </span>
              <span class="wbal loading" *ngIf="saldoDe(o) === null"
                >Cargando saldo…</span
              >
            </span>
            <span class="wtag" *ngIf="saldoNoAlcanza(o)">No alcanza</span>
          </button>
        </div>

        <p class="bal-note" *ngIf="origen === 'CLP'">
          Tu saldo en pesos incluye el cupo de sobregiro disponible.
        </p>

        <!-- ═══ País destino (reactivo al origen) ═══ -->
        <div class="sect-label">¿A qué país envías?</div>
        <div class="countries">
          <button
            *ngFor="let d of destinos"
            type="button"
            class="country"
            [class.on]="destino === d.code"
            [class.closed]="esDestinoCerrado(d.code)"
            [disabled]="esDestinoCerrado(d.code)"
            (click)="selectDestino(d.code)"
          >
            <img class="flag" [src]="d.flag" [alt]="d.nombre" />
            <span class="cname">{{ d.nombre }}</span>
            <span class="ccur">{{ d.moneda }}</span>
            <span class="closed-tag" *ngIf="esDestinoCerrado(d.code)"
              >Cerrado</span
            >
          </button>
        </div>

        <p class="s2-msg" *ngIf="cargandoDestinos" style="padding: 14px 8px">
          Cargando destinos disponibles…
        </p>

        <p class="hint-closed" *ngIf="sinDestinos && !destinosVitaFallo">
          No hay destinos disponibles para esta moneda en este momento. Prueba
          con otra forma de pago o vuelve más tarde.
        </p>

        <!-- La consulta de disponibilidad falló: la grilla no puede quedar a
             medias sin salida. -->
        <p class="hint-closed" *ngIf="destinosVitaFallo && !cargandoDestinos">
          No pudimos verificar todos los destinos.
          <button type="button" class="linkbtn" (click)="reintentarDestinos()">
            Reintentar
          </button>
        </p>

        <!-- Chileno: los bolívares también pueden quedar en su saldo VES
             (CLP → comprar-bolivares · USDT → convert-usdt-ves a la wallet). -->
        <p class="bal-note" *ngIf="ofreceGuardarEnSaldoVes">
          ¿Prefieres guardar los bolívares en tu saldo VES en vez de enviarlos?
          Después puedes enviarlos, retirarlos o convertirlos.
          <button type="button" class="linkbtn" [disabled]="navegando" (click)="irAGuardarEnSaldoVes()">
            Guardar en mi saldo VES
          </button>
        </p>

        <!-- Chileno pagando con bolívares: solo salen a su cuenta en Chile. -->
        <p class="bal-note" *ngIf="perfil === 'CL' && origen === 'VES'">
          Con tu saldo en bolívares puedes enviar pesos a tu propia cuenta en
          Chile.
        </p>

        <p class="hint-closed" *ngIf="!fiatAbierto && !(perfil === 'CL' && origen === 'VES')">
          Los envíos a Venezuela y Chile están fuera de horario. Colombia y Perú
          siguen operativos.
        </p>
        <!-- Chileno pagando con VES: su único destino es su cuenta en Chile. -->
        <p class="hint-closed" *ngIf="!fiatAbierto && perfil === 'CL' && origen === 'VES'">
          Los envíos a tu cuenta en Chile están fuera de horario. Podrás hacerlo
          cuando se reabran.
        </p>

        <ng-container *ngIf="destino">
          <!-- Riel Colombia: el usuario elige cómo llega -->
          <ng-container *ngIf="destino === 'CO'">
            <div class="sect-label">¿Cómo lo entregamos?</div>
            <div class="methods">
              <button
                type="button"
                class="method"
                [class.on]="rielCo === 'COBREB'"
                (click)="selectRielCo('COBREB')"
              >
                <span class="mi">
                  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M13 2 4.5 13.5H11l-1 8.5 8.5-11.5H12l1-8.5Z" fill="currentColor" />
                  </svg>
                </span>
                <span class="mtxt">
                  <b>Bre-B</b>
                  <small>Instantáneo · menos de 1 hora</small>
                </span>
                <span class="chk"></span>
              </button>
              <button
                type="button"
                class="method"
                [class.on]="rielCo === 'CO'"
                (click)="selectRielCo('CO')"
              >
                <span class="mi">
                  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M3 9.5 12 4l9 5.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M5.5 10.5v7M9.5 10.5v7M14.5 10.5v7M18.5 10.5v7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
                    <path d="M3.5 20.5h17" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
                  </svg>
                </span>
                <span class="mtxt">
                  <b>Transferencia bancaria</b>
                  <small>{{ etaBancarioCo }}</small>
                </span>
                <span class="chk"></span>
              </button>
            </div>
          </ng-container>

          <!-- ═══ Monto ═══ -->
          <div class="sect-label">Tú envías</div>
          <div class="amount">
            <label for="hub-monto">Monto a enviar</label>
            <div class="amount-row">
              <!-- `type=text` + `appMonto`: separador de miles en vivo. Con
                   `type=number` el navegador vacía el campo apenas aparece una
                   coma, así que 1,250,000 no se puede mostrar mientras se tipea. -->
              <input
                id="hub-monto"
                type="text"
                inputmode="numeric"
                appMonto
                [decimales]="decimalesOrigen"
                [(ngModel)]="monto"
                (ngModelChange)="onMontoChange()"
                placeholder="0"
              />
              <span class="cur">{{ origen }}</span>
              <button
                *ngIf="montoMaximo != null"
                type="button"
                class="max"
                (click)="usarMaximo()"
              >
                MÁX
              </button>
            </div>
            <div class="chips">
              <button
                *ngFor="let c of chips"
                type="button"
                (click)="aplicarChip(c)"
              >
                {{ c | number: "1.0-0" }}
              </button>
            </div>
          </div>

          <p class="minhint" *ngIf="cotizacion?.min != null && !bloqueo">
            Mínimo {{ cotizacion?.min | number: "1.0-0" }}
            {{ cotizacion?.monedaOrigen }}
            <ng-container *ngIf="cotizacion?.max != null">
              · máximo {{ cotizacion?.max | number: "1.0-0" }}
              {{ cotizacion?.monedaOrigen }}
            </ng-container>
          </p>
        </ng-container>
      </section>

      <!-- ═══════════ Columna: qué recibe ═══════════ -->
      <section class="col col-result" *ngIf="destino">
        <div class="sect-label">Recibe</div>

        <div class="rate-card" [class.loading]="cotizando">
          <label class="recv-l" for="hub-recibe">
            El beneficiario recibe
            <small>· editable</small>
          </label>

          <!-- Campo editable: se puede cotizar por lo que paga el cliente o por
               lo que recibe el beneficiario. Al salir del campo se ajusta al
               recibe real de la cotización — el monto de origen tiene que ser
               pagable, así que el objetivo tipeado casi nunca cae exacto. -->
          <div class="recv-row">
            <input
              id="hub-recibe"
              type="text"
              inputmode="numeric"
              appMonto
              [decimales]="decimalesDestino"
              [(ngModel)]="montoDestino"
              (ngModelChange)="onMontoDestinoChange()"
              (focus)="onFocoDestino()"
              (blur)="onBlurDestino()"
              placeholder="0"
            />
            <span class="rc">{{
              cotizacion?.monedaDestino || destinoMeta?.moneda
            }}</span>
          </div>

          <div class="recv-state skeleton" *ngIf="cotizando">Calculando…</div>

          <div
            class="recv-state"
            *ngIf="
              !cotizando &&
              direccion === 'DESTINO' &&
              cotizacion?.recibe != null
            "
          >
            Pagas {{ cotizacion?.monto | number: "1.0-2" }}
            {{ cotizacion?.monedaOrigen }}
          </div>

          <!-- Una sola tasa, nombrada. Con referencia disponible se muestra
               ÉSA: la diferencia con la aplicada ya viaja como comisión. -->
          <div class="rateline" *ngIf="tasaVisible">
            <span class="rl">
              <ng-container *ngIf="hayReferencia"
                >Tasa de referencia:
              </ng-container>
              1 {{ cotizacion?.monedaOrigen }} =
              {{ tasaVisible | number: fmtTasa }}
              {{ cotizacion?.monedaDestino }}
            </span>
            <span class="eta">Llega en {{ cotizacion?.etaLabel }}</span>
          </div>
        </div>

        <!-- Los límites se muestran SÓLO en moneda de origen (columna de la
             izquierda): son los que valida el backend y los únicos que se
             pueden dar exactos. Convertirlos acá obligaba a inventar una tasa
             por monto y el número no cuadraba con el resto de la pantalla. -->

        <!-- ═══ Desglose — la comisión honesta ═══ -->
        <div class="break" *ngIf="puedeDesplegarDesglose">
          <button
            type="button"
            class="break-sum"
            (click)="desgloseAbierto = !desgloseAbierto"
          >
            <span>Ver desglose</span>
            <span class="cv">
              <ng-container *ngIf="cotizacion?.sinComision"
                >Sin comisión</ng-container
              >
              <ng-container *ngIf="hayComision">
                Comisión {{ cotizacion?.comision | number: fmtComision }}
                {{ cotizacion?.monedaDestino }}
              </ng-container>
            </span>
          </button>

          <!-- El orden es el de la cuenta que el cliente puede rehacer:
               monto × tasa = subtotal, subtotal − comisión = recibe. Todo en
               moneda de destino de la fila del subtotal para abajo. -->
          <div class="break-det" *ngIf="desgloseAbierto">
            <div class="drow">
              <span>Tú envías</span>
              <b
                >{{ cotizacion?.monto | number: "1.0-2" }}
                {{ cotizacion?.monedaOrigen }}</b
              >
            </div>

            <!-- Una sola fila de tasa, con su unidad. -->
            <div class="drow" *ngIf="tasaVisible">
              <span>{{ etiquetaTasa }}</span>
              <b>
                1 {{ cotizacion?.monedaOrigen }} =
                {{ tasaVisible | number: fmtTasa }}
                {{ cotizacion?.monedaDestino }}
              </b>
            </div>

            <div class="drow" *ngIf="hayComision && subtotal != null">
              <span>Subtotal</span>
              <b
                >{{ subtotal | number: cotizacion?.decimales }}
                {{ cotizacion?.monedaDestino }}</b
              >
            </div>

            <!-- Sólo los rieles COP y PEN cobran comisión. -->
            <div class="drow" *ngIf="cotizacion?.sinComision">
              <span>Comisión</span>
              <b class="free">Sin comisión</b>
            </div>
            <div class="drow" *ngIf="hayComision">
              <span>Comisión</span>
              <b
                >− {{ cotizacion?.comision | number: fmtComision }}
                {{ cotizacion?.monedaDestino }}</b
              >
            </div>

            <div class="drow total">
              <span>Recibe</span>
              <b
                >{{ cotizacion?.recibe | number: cotizacion?.decimales }}
                {{ cotizacion?.monedaDestino }}</b
              >
            </div>
          </div>
        </div>

        <!-- Cupo de registro disponible (empresa pre-aprobada), informativo:
             se muestra mientras el monto NO supere el tope. -->
        <p class="minhint" *ngIf="cupoAplica && !cupoExcedido">
          Registro pre-aprobado · disponible
          <b>{{ cupoDisponible | number: '1.0-0' }} CLP</b> para enviar.
          <a
            class="cupo-link"
            (click)="irACompletarRegistro()"
            style="cursor: pointer; text-decoration: underline"
            >Completar registro de empresa</a
          >
        </p>

        <!-- ═══ Avisos ═══ -->
        <div class="alert" *ngIf="otroBloqueo">{{ otroBloqueo }}</div>

        <!-- Cupo de registro superado: bloqueo con CTA para completar el
             registro y operar sin tope. En ámbar porque el usuario puede
             resolverlo (bajando el monto o completando el registro). -->
        <div class="alert warn" *ngIf="cupoExcedido">
          <span class="alert-txt">
            <b>Tu registro está pre-aprobado.</b>
            Puedes enviar hasta {{ cupoDisponible | number: '1.0-0' }} CLP.
            Completa el registro de tu empresa para operar sin este límite.
          </span>
          <button
            type="button"
            class="btn warn-cta"
            [disabled]="navegando"
            (click)="irACompletarRegistro()"
          >
            Completar registro
          </button>
        </div>

        <!-- Falta de saldo: es el único bloqueo que el usuario puede resolver
             solo, así que va en ámbar y con la recarga de SU moneda de pago,
             no en rojo y sin salida. Convive con el aviso de arriba: en los
             rieles Vita lo normal es que el monto esté bajo el mínimo Y que el
             saldo tampoco alcance para cubrirlo.
             30/10/2026: el chileno no recarga bolívares. Pagando con VES el
             aviso queda sin botón (`ofreceRecarga`); el VE lo conserva. -->
        <div class="alert warn" *ngIf="faltaSaldo">
          <span class="alert-txt">
            <b>Te falta saldo en {{ origen }}.</b>
            Tienes {{ saldoActual | number: decimalesSaldo(origen) }}
            {{ origen }}
            <ng-container *ngIf="saldoInsuficiente; else faltaParaMinimo">
              y este envío necesita
              {{ monto | number: decimalesSaldo(origen) }} {{ origen }}.
            </ng-container>
            <ng-template #faltaParaMinimo>
              y el mínimo para este destino es
              {{ cotizacion?.min | number: decimalesSaldo(origen) }}
              {{ origen }}.
            </ng-template>
          </span>
          <button
            *ngIf="ofreceRecarga"
            type="button"
            class="btn warn-cta"
            [disabled]="navegando"
            (click)="irARecargar()"
          >
            Recargar {{ origen }}
          </button>
        </div>

        <!-- CTA de escritorio: acompaña al resultado -->
        <div class="cta-desktop">
          <button
            type="button"
            class="btn primary"
            [disabled]="!puedeContinuar"
            (click)="continuar()"
          >
            Continuar a beneficiario &rarr;
          </button>
          <p class="cta-note">
            La tasa se vuelve a validar al confirmar el envío.
          </p>
        </div>
      </section>

      <!-- Estado vacío: ocupa el ancho completo de la grilla -->
      <p class="placeholder" *ngIf="!destino">
        Elige un país para ver cuánto recibe tu beneficiario.
      </p>
    </div>

    <!-- CTA de móvil/tablet: al final del flujo -->
    <div class="cta-mobile" *ngIf="paso === 'cotizacion'">
      <button
        type="button"
        class="btn primary"
        [disabled]="!puedeContinuar"
        (click)="continuar()"
      >
        Continuar a beneficiario &rarr;
      </button>
      <p class="cta-note">La tasa se vuelve a validar al confirmar el envío.</p>
    </div>
  </div>
</div>
